import uniq from "lodash.uniq";
import { Mail, MailQuestionMark, MailCheck, Zap, Bot, UserCheck, PlusSquare, Pencil, Table, CalendarPlus, CalendarSync, CalendarCheck, UserPlus, LayoutDashboard } from "lucide-react";
import { ReadOnlyStepProps, StepEditorProps } from "./step-editors/useStepEditor";
import { GoogleSheetRowStepEditor } from "./step-editors/googlesheetrow/GoogleSheetRowStepEditor";
import { CompletedGoogleSheetRow } from "./step-editors/googlesheetrow/CompletedGoogleSheetRow";
import { EmailStepEditor } from "./step-editors/email/EmailStepEditor";
import { EmailStepViewer } from "./step-editors/email/EmailStepViewer";
import {
  DoceboIcon,
  DocuSignIcon,
  GoodyIcon,
  JiraIcon,
  LinearIcon,
  SlackIcon,
  TeamsIcon,
  WebhookIcon
} from "../../assets";
import { SlackChannelMessageEditor } from "./step-editors/slack/SlackChannelMessageEditor";
import { SlackChannelMessageViewer } from "./step-editors/slack/SlackChannelMessageViewer";
import { SlackDirectMessageEditor } from "./step-editors/slack/SlackDirectMessageEditor";
import { SlackDirectMessageViewer } from "./step-editors/slack/SlackDirectMessageViewer";
import { SlackQuestionMessageEditor } from "./step-editors/slack/SlackQuestionMessageEditor";
import { SlackQuestionMessageViewer } from "./step-editors/slack/SlackQuestionMessageViewer";
import { WorkflowTriggerStepEditor } from "./step-editors/workflowtrigger/WorkflowTriggerStepEditor";
import { WorkflowTriggerStepViewer } from "./step-editors/workflowtrigger/WorkflowTriggerStepViewer";
import { MeetingStepEditor } from "./step-editors/meeting/MeetingStepEditor";
import { MeetingStepViewer } from "./step-editors/meeting/MeetingStepViewer";
import { useWorkspace } from "../../IdentityProvider";
import { DoceboLearningPlanEditor } from "./step-editors/docebo/DoceboLearningPlanEditor";
import { DoceboLearningPlanViewer } from "./step-editors/docebo/DoceboLearningPlanViewer";
import { TrelloBoardStepEditor } from "./step-editors/trello/TrelloBoardStepEditor";
import { TrelloBoardStepViewer } from "./step-editors/trello/TrelloBoardStepViewer";
import { SlackFormMessageEditor } from "./step-editors/slack/SlackFormMessageEditor";
import { SlackFormnMessageViewer } from "./step-editors/slack/SlackFormMessageViewer";
import { EmailFormStepEditor } from "./step-editors/email/EmailFormStepEditor";
import { EmailFormStepViewer } from "./step-editors/email/EmailFormStepViewer";
import { TeamsChannelMessageEditor } from "./step-editors/teams/TeamsChannelMessageEditor";
import { TeamsChannelMessageViewer } from "./step-editors/teams/TeamsChannelMessageViewer";
import { TeamsChatMessageEditor } from "./step-editors/teams/TeamsChatMessageEditor";
import { TeamsChatMessageViewer } from "./step-editors/teams/TeamsChatMessageViewer";
import { GoodySendGiftEditor } from "./step-editors/goody/GoodySendGiftEditor";
import { GoodySendGiftViewer } from "./step-editors/goody/GoodySendGiftViewer";
import { useFeatureFlags } from "hooks";
import { JiraIssueStepEditor } from "./step-editors/jira/JiraIssueStepEditor";
import { JiraIssueStepViewer } from "./step-editors/jira/JiraIssueStepViewer";
import { HibobUpdateStepEditor } from "./step-editors/hibob/HibobUpdateStepEditor";
import { HibobUpdateStepViewer } from "./step-editors/hibob/HibobUpdateStepViewer";
import { HibobWorkEntryStepEditor } from "./step-editors/hibob/HibobWorkEntryStepEditor";
import { HibobWorkEntryStepViewer } from "./step-editors/hibob/HibobWorkEntryStepViewer";
import { HibobUpdateEmailStepEditor } from "./step-editors/hibob/HibobUpdateEmailStepEditor";
import { HibobUpdateEmailStepViewer } from "./step-editors/hibob/HibobUpdateEmailStepViewer";
import { ApiCallStepEditor } from "./step-editors/apicall/ApiCallStepEditor";
import { ApiCallStepViewer } from "./step-editors/apicall/ApiCallStepViewer";
import { CreateAccountStepEditor } from "./step-editors/createaccount/CreateAccountStepEditor";
import { CreateAccountStepViewer } from "./step-editors/createaccount/CreateAccountStepViewer";
import { AttendToEventStepEditor } from "./step-editors/eventattend/AttendToEventStepEditor";
import { AttendToEventStepViewer } from "./step-editors/eventattend/AttendToEventStepViewer";
import { SlackChannelInviteEditor } from "./step-editors/slack/SlackChannelInviteStepEditor";
import { SlackChannelInviteViewer } from "./step-editors/slack/SlackChannelInviteStepViewer";
import { SlackChannelRemoveEditor } from "./step-editors/slack/SlackChannelRemoveStepEditor";
import { SlackChannelRemoveViewer } from "./step-editors/slack/SlackChannelRemoveStepViewer";
import { EmployeeAssignStepEditor } from "./step-editors/employeeassign/EmployeeAssignStepEditor";
import { EmployeeAssignStepViewer } from "./step-editors/employeeassign/EmployeeAssignStepViewer";
import { SlackChannelCreateEditor } from "./step-editors/slack/SlackChannelCreateStepEditor";
import { SlackChannelCreateViewer } from "./step-editors/slack/SlackChannelCreateStepViewer";
import { DatasetEntryCreateEditor } from "./step-editors/datasets/DatasetEntryCreateEditor";
import { DatasetEntryCreateViewer } from "./step-editors/datasets/DatasetEntryCreateViewer";
import { AiActionStepEditor } from "./step-editors/aiaction/AiActionStepEditor";
import { AiActionStepViewer } from "./step-editors/aiaction/AiActionStepViewer";
import { DatasetEntryUpdateEditor } from "./step-editors/datasets/DatasetEntryUpdateEditor";
import { DatasetEntryUpdateViewer } from "./step-editors/datasets/DatasetEntryUpdateViewer";
import { EmailFormV3StepEditor } from "./step-editors/email/formv3/EmailFormV3StepEditor";
import { EmailFormV3StepViewer } from "./step-editors/email/formv3/EmailFormV3StepViewer";
import { EmailTaskV2StepEditor } from "./step-editors/email/taskv2/EmailTaskV2StepEditor";
import { EmailTaskV2StepViewer } from "./step-editors/email/taskv2/EmailTaskV2StepViewer";
import { EmailV2StepEditor } from "./step-editors/email/v2/EmailV2StepEditor";
import { EmailV2StepViewer } from "./step-editors/email/v2/EmailV2StepViewer";
import { DataSourceIcon } from "../datasources/components/DataSourceIcon";
import { HarvestCreateTimeEntryStepEditor } from "./step-editors/harvest/CreateTimeEntryStepEditor";
import { HarvestCreateTimeEntryStepViewer } from "./step-editors/harvest/CreateTimeEntryStepViewer";
import { HarvestCreateMultidayTimeEntryStepEditor } from "./step-editors/harvest/CreateMultidayTimeEntryStepEditor";
import { HarvestCreateMultidayTimeEntryStepViewer } from "./step-editors/harvest/CreateMultidayTimeEntryStepViewer";
import { HarvestUpdateTimeEntryStepEditor } from "./step-editors/harvest/UpdateTimeEntryStepEditor";
import { HarvestUpdateTimeEntryStepViewer } from "./step-editors/harvest/UpdateTimeEntryStepViewer";
import { HarvestUpdateMultidayTimeEntryStepEditor } from "./step-editors/harvest/UpdateMultidayTimeEntryStepEditor";
import { HarvestUpdateMultidayTimeEntryStepViewer } from "./step-editors/harvest/UpdateMultidayTimeEntryStepViewer";
import { HarvestDeleteTimeEntryStepEditor } from "./step-editors/harvest/DeleteTimeEntryStepEditor";
import { HarvestDeleteTimeEntryStepViewer } from "./step-editors/harvest/DeleteTimeEntryStepViewer";
import { DocuSignStepEditor, DocuSignStepViewer } from "./step-editors/docusign";
import { LinearIssueStepEditor } from "./step-editors/linear/LinearIssueStepEditor";
import { LinearIssueStepViewer } from "./step-editors/linear/LinearIssueStepViewer";

export type WorkflowStepType = {
  stepType: string;
  title: string;
  description: string;
  category: string;
  Editor?: (props: StepEditorProps) => JSX.Element;
  Viewer?: (props: ReadOnlyStepProps) => JSX.Element;
  template?: any;
  icon?: JSX.Element;
  hidden?: boolean;
  statusDescription?: { [index: string]: string };
  scheduleDescription?: { [index: string]: string };
  basicPlan?: boolean;
  featureFlag?: string;
  hideWhenEnabled?: string;
};

export const WorkflowStepTypes: WorkflowStepType[] = [
  {
    stepType: "email",
    title: "Email Message",
    description: "Send an email to an employee or third party.",
    category: "messaging",
    Editor: EmailStepEditor,
    Viewer: EmailStepViewer,
    basicPlan: true,
    hidden: true
  },
  {
    stepType: "emailv2",
    title: "Email Message",
    description: "Send an email to an employee or third party.",
    category: "messaging",
    icon: <Mail size={16} color="var(--palette-primary-default)" />,
    Editor: EmailV2StepEditor,
    Viewer: EmailV2StepViewer,
    basicPlan: true,
    template: {
      langs: {
        items: [],
        defaultValue: { subject: "", message: "" }
      }
    }
  },
  {
    stepType: "slackcm",
    title: "Slack Channel Message",
    description: "Send a message to a Slack channel",
    category: "messaging",
    icon: <SlackIcon />,
    Editor: SlackChannelMessageEditor,
    Viewer: SlackChannelMessageViewer,
    basicPlan: true
  },
  {
    stepType: "slackdm",
    title: "Slack Direct Message",
    description: "Send a message to user or group of users in Slack",
    category: "messaging",
    icon: <SlackIcon />,
    Editor: SlackDirectMessageEditor,
    Viewer: SlackDirectMessageViewer,
    template: {
      users: [],
      langs: {
        items: [],
        defaultValue: ""
      }
    },
    basicPlan: true
  },
  {
    stepType: "slackqm",
    title: "Slack Question Message",
    description: "Fill employee information by asking a person to fill it in Slack",
    category: "messaging",
    icon: <SlackIcon />,
    Editor: SlackQuestionMessageEditor,
    Viewer: SlackQuestionMessageViewer,
    template: {
      users: [],
      langs: {
        items: [],
        defaultValue: ""
      }
    },
    basicPlan: true
  },
  {
    stepType: "slackform",
    title: "Slack Form",
    description: "Send a Slack Form",
    category: "forms",
    icon: <SlackIcon />,
    Editor: SlackFormMessageEditor,
    Viewer: SlackFormnMessageViewer,
    template: {
      users: []
    },
    basicPlan: true
  },
  {
    stepType: "emailformv2",
    title: "Email Form",
    description: "Send a Form via Email",
    category: "forms",
    icon: <MailQuestionMark size={16} color="var(--palette-primary-default)" />,
    Editor: EmailFormStepEditor,
    Viewer: EmailFormStepViewer,
    template: {
      message:
        "Please make sure to include the {{link-to-form}} tag in your message. This tag will automatically be replaced with the appropriate form link when the email is sent."
    },
    hidden: true
  },
  {
    stepType: "emailformv3",
    title: "Email Form",
    description: "Send a Form via Email",
    category: "forms",
    icon: <MailQuestionMark size={16} color="var(--palette-primary-default)" />,
    Editor: EmailFormV3StepEditor,
    Viewer: EmailFormV3StepViewer
  },
  {
    stepType: "emailtaskv2",
    title: "Email Task",
    description: "Send a Task via Email",
    category: "tasks",
    icon: <MailCheck size={16} color="var(--palette-primary-default)" />,
    Editor: EmailTaskV2StepEditor,
    Viewer: EmailTaskV2StepViewer,
    featureFlag: "tasks",
    template: {
      langs: {
        items: [],
        defaultValue: { subject: "", message: "" }
      }
    }
  },
  {
    stepType: "teamscm",
    title: "Teams Channel Message",
    description: "Send a message to a Teams channel",
    category: "messaging",
    icon: <TeamsIcon />,
    Editor: TeamsChannelMessageEditor,
    Viewer: TeamsChannelMessageViewer
  },
  {
    stepType: "teamsdm",
    title: "Teams Chat Message",
    description: "Send a message to user or group of users in Teams",
    category: "messaging",
    icon: <TeamsIcon />,
    Editor: TeamsChatMessageEditor,
    Viewer: TeamsChatMessageViewer,
    template: {
      users: []
    }
  },
  {
    stepType: "goody",
    title: "Send Gift with Goody",
    description: "Send a gift through Goody.",
    category: "Engagement and Recognition",
    icon: <GoodyIcon />,
    Editor: GoodySendGiftEditor,
    Viewer: GoodySendGiftViewer,
    featureFlag: "goody"
  },
  {
    stepType: "meeting",
    title: "Calendar Meeting",
    description: "Set up a one-time calendar event",
    category: "scheduling",
    icon: <CalendarPlus size={16} color="var(--palette-success-default)" />,
    //hidden: true,
    statusDescription: {
      scheduled: "Created",
      delivered: "Scheduled"
    },
    scheduleDescription: {
      scheduled: "Send invites at",
      delivered: "Meeting time"
    },
    Editor: MeetingStepEditor,
    Viewer: MeetingStepViewer,
    template: {
      attendees: [],
      dateTrigger: {
        amount: 5,
        period: "days",
        side: "after",
        reference: "enroll"
      },
      fromTime: "10:00",
      toTime: "11:00",
      syncContent: true,
      syncAttendees: true,
      attendeeDeclineAction: "fail",
      meetingRoomType: "none",
      meetingRooms: []
    },
    basicPlan: true
  },
  {
    stepType: "event",
    title: "Calendar event",
    description: "Calendar meeting or event",
    category: "scheduling",
    hidden: true,
    statusDescription: {
      scheduled: "Created",
      delivered: "Scheduled"
    }
  },
  {
    stepType: "common-event",
    title: "Calendar event",
    description: "Calendar meeting or event",
    category: "scheduling",
    hidden: true,
    statusDescription: {
      scheduled: "Created",
      delivered: "Scheduled"
    }
  },
  {
    stepType: "individual-event",
    title: "Meeting",
    description: "Set up a one-time calendar event",
    category: "scheduling",
    hidden: true,
    statusDescription: {
      scheduled: "Created",
      delivered: "Scheduled"
    }
  },
  {
    stepType: "invite",
    title: "Invite to recurring event",
    description: "Invite employee to recurring event",
    category: "scheduling",
    icon: <CalendarSync size={16} color="var(--palette-success-default)" />
  },
  {
    stepType: "eventattend",
    title: "Attend to event",
    description: "Attend to event",
    category: "scheduling",
    icon: <CalendarCheck size={16} color="var(--palette-success-default)" />,
    statusDescription: {
      scheduled: "Invited",
      delivered: "Attends"
    },
    Editor: AttendToEventStepEditor,
    Viewer: AttendToEventStepViewer
  },
  {
    stepType: "workflowtrigger",
    title: "Launch an automation",
    description: "Automatically start another workflow.",
    category: "productivity",
    icon: <Zap size={16} />,
    Editor: WorkflowTriggerStepEditor,
    Viewer: WorkflowTriggerStepViewer,
    basicPlan: true
  },
  {
    stepType: "aiaction",
    title: "AI Action",
    description: "Instruct AI to perform a specific action",
    category: "productivity",
    icon: <Bot size={16} />,
    Editor: AiActionStepEditor,
    Viewer: AiActionStepViewer
  },
  {
    stepType: "slack",
    title: "Slack message",
    description: "Send a message to either a channel or through direct messaging",
    category: "messaging",
    hidden: true
  },
  {
    stepType: "slacktask",
    title: "Slack task",
    description: "Send task via Slack and track completion",
    category: "tasks"
  },
  {
    stepType: "emailtask",
    title: "Email task",
    description: "Distribute tasks via email and monitor their progress",
    category: "tasks",
    hideWhenEnabled: "tasks"
  },
  {
    stepType: "docebo-lp-enroll",
    title: "Enroll to Learning Plan",
    description: "Enroll an employee to a Learning Plan in Docebo",
    category: "lms",
    icon: <DoceboIcon />,
    Editor: DoceboLearningPlanEditor,
    Viewer: DoceboLearningPlanViewer,
    featureFlag: "docebo"
  },
  {
    stepType: "slackquestion",
    title: "Slack question",
    description: "Send question via Slack and utilise the answer",
    category: "data",
    hidden: true
  },
  {
    stepType: "emailform",
    title: "Email form",
    description: "Gather information using a form distributed via email",
    category: "data",
    hidden: true
  },
  {
    stepType: "enroll",
    title: "Start another workflow",
    description: "Automatically start another workflow.",
    category: "productivity",
    hidden: true
  },
  {
    stepType: "createaccount",
    title: "Create account",
    description: "Automatically create account to your data sources",
    category: "productivity",
    icon: <UserPlus size={16} />,
    Editor: CreateAccountStepEditor,
    Viewer: CreateAccountStepViewer
  },
  {
    stepType: "trelloboard",
    title: "Create Trello board",
    description: "Create a board to Trello from template",
    category: "productivity",
    icon: <LayoutDashboard size={16} />,
    Editor: TrelloBoardStepEditor,
    Viewer: TrelloBoardStepViewer,
    template: {
      members: []
    }
  },
  {
    stepType: "employeeselect",
    title: "Assign an employee",
    description: "Assign related employee such as manager or buddy",
    category: "productivity",
    hidden: true
  },
  {
    stepType: "employeeassign",
    title: "Assign an employee",
    description: "Assign related employee such as manager or buddy",
    category: "productivity",
    Editor: EmployeeAssignStepEditor,
    Viewer: EmployeeAssignStepViewer,
    icon: <UserCheck size={16} />
  },
  {
    stepType: "dataset-entry-create",
    title: "Create data",
    description: "Create new entry in a dataset",
    category: "productivity",
    Editor: DatasetEntryCreateEditor,
    Viewer: DatasetEntryCreateViewer,
    icon: <PlusSquare size={16} />
  },
  {
    stepType: "dataset-entry-update",
    title: "Update data",
    description: "Update entry in a dataset",
    category: "productivity",
    Editor: DatasetEntryUpdateEditor,
    Viewer: DatasetEntryUpdateViewer,
    icon: <Pencil size={16} />
  },
  {
    stepType: "googlesheetrow",
    title: "Add Sheet row",
    description: "Add a row to a Google Sheet",
    category: "productivity",
    Editor: GoogleSheetRowStepEditor,
    Viewer: CompletedGoogleSheetRow,
    icon: <Table size={16} />
  },
  {
    stepType: "jira",
    title: "Jira Issue",
    description: "Create an issue to Jira",
    category: "productivity",
    icon: <JiraIcon />,
    Editor: JiraIssueStepEditor,
    Viewer: JiraIssueStepViewer
  },
  {
    stepType: "hibob-update",
    title: "Update HiBob Field",
    description: "Update an employee field in HiBob",
    category: "hibob",
    icon: <DataSourceIcon dataSource="hibob" size="small" />,
    Editor: HibobUpdateStepEditor,
    Viewer: HibobUpdateStepViewer,
    template: {
      datasourceId: "",
      fieldId: "",
      value: "",
      failOnError: true
    }
  },
  {
    stepType: "hibob-work-entry",
    title: "Create HiBob Work Entry",
    description: "Create a new work entry (employment history record) in HiBob",
    category: "hibob",
    icon: <DataSourceIcon dataSource="hibob" size="small" />,
    Editor: HibobWorkEntryStepEditor,
    Viewer: HibobWorkEntryStepViewer
  },
  {
    stepType: "hibob-update-email",
    title: "Update HiBob Email",
    description: "Update an employee's email address in HiBob",
    category: "hibob",
    icon: <DataSourceIcon dataSource="hibob" size="small" />,
    Editor: HibobUpdateEmailStepEditor,
    Viewer: HibobUpdateEmailStepViewer,
    template: {
      datasourceId: "",
      email: ""
    }
  },
  {
    stepType: "slackchannelinvite",
    title: "Invite to Slack channel",
    description: "Invite employees to public or private Slack channel",
    category: "productivity",
    icon: <SlackIcon />,
    Editor: SlackChannelInviteEditor,
    Viewer: SlackChannelInviteViewer
  },
  {
    stepType: "slackchannelremove",
    title: "Remove from Slack channel",
    description: "Remove employees from a public or private Slack channel",
    category: "productivity",
    icon: <SlackIcon />,
    Editor: SlackChannelRemoveEditor,
    Viewer: SlackChannelRemoveViewer,
    template:{
      users: []
    }
  },
  {
    stepType: "slackchannelcreate",
    title: "Create Slack channel",
    description: "Create public or private Slack channel",
    category: "productivity",
    icon: <SlackIcon />,
    Editor: SlackChannelCreateEditor,
    Viewer: SlackChannelCreateViewer,
    template: {
      privateChannel: false
    }
  },
  {
    stepType: "webhook",
    title: "Webhook",
    description: "Custom webhook action",
    category: "productivity",
    hidden: true
  },
  {
    stepType: "apicall",
    title: "Make an api call",
    description: "Use list of supported integrations to make custom API calls",
    category: "productivity",
    icon: <WebhookIcon />,
    Editor: ApiCallStepEditor,
    Viewer: ApiCallStepViewer
  },
  {
    stepType: "harvest_create-time-entry",
    title: "Create Time Entry",
    description: "Create a time entry in Harvest",
    category: "harvest",
    icon: <DataSourceIcon dataSource="harvest" size="small" />,
    Editor: HarvestCreateTimeEntryStepEditor,
    Viewer: HarvestCreateTimeEntryStepViewer
  },
  {
    stepType: "harvest_create-multiday-time-entry",
    title: "Create Multiday Time Entry",
    description: "Create a multiday time entry in Harvest",
    category: "harvest",
    icon: <DataSourceIcon dataSource="harvest" size="small" />,
    Editor: HarvestCreateMultidayTimeEntryStepEditor,
    Viewer: HarvestCreateMultidayTimeEntryStepViewer
  },
  {
    stepType: "harvest_update-time-entry",
    title: "Update Time Entry",
    description: "Update an existing time entry in Harvest",
    category: "harvest",
    icon: <DataSourceIcon dataSource="harvest" size="small" />,
    Editor: HarvestUpdateTimeEntryStepEditor,
    Viewer: HarvestUpdateTimeEntryStepViewer
  },
  {
    stepType: "harvest_update-multiday-time-entry",
    title: "Update Multiday Time Entry",
    description: "Update an existing multiday time entry in Harvest",
    category: "harvest",
    icon: <DataSourceIcon dataSource="harvest" size="small" />,
    Editor: HarvestUpdateMultidayTimeEntryStepEditor,
    Viewer: HarvestUpdateMultidayTimeEntryStepViewer
  },
  {
    stepType: "harvest_delete-time-entry",
    title: "Delete Time Entry",
    description: "Delete a time entry in Harvest",
    category: "harvest",
    icon: <DataSourceIcon dataSource="harvest" size="small" />,
    Editor: HarvestDeleteTimeEntryStepEditor,
    Viewer: HarvestDeleteTimeEntryStepViewer
  },
  {
    stepType: "docusign",
    title: "DocuSign eSign",
    description: "Send a document for signing via DocuSign",
    category: "productivity",
    icon: <DocuSignIcon />,
    Editor: DocuSignStepEditor,
    Viewer: DocuSignStepViewer,
    statusDescription: {
      scheduled: "Scheduled",
      delivered: "Sent for signing"
    }
  },
  {
    stepType: "linear",
    title: "Linear Ticket",
    description: "Create a ticket in Linear",
    category: "productivity",
    icon: <LinearIcon />,
    Editor: LinearIssueStepEditor,
    Viewer: LinearIssueStepViewer,
    statusDescription: {
      delivered: "Ticket created, awaiting resolution"
    }
  }
];

export const StepTypeCategories = uniq(WorkflowStepTypes.map(stepType => stepType.category));

export const useStepType = (stepType: string, eventType?: string): WorkflowStepType => {
  const newStepType = WorkflowStepTypes.find(type => type.stepType === stepType);
  if (!newStepType) {
    throw new Error(`Step type ${stepType} not found`);
  }

  if (newStepType.stepType === "event") {
    if (eventType === "common") newStepType.title = "Event";
    if (eventType === "individual") newStepType.title = "Meeting";
  }

  return newStepType;
};

export const useStepTypes = (): WorkflowStepType[] => {
  const { isEnabled } = useFeatureFlags();
  const workspace = useWorkspace();
  const hasFeatureFlagActivated = (flagName: string) => {
    return isEnabled(flagName);
  };
  if (workspace?.plan === "basic") return WorkflowStepTypes.filter(stepType => stepType.basicPlan);
  return WorkflowStepTypes.filter(_ => {
    if (!!_.featureFlag && !hasFeatureFlagActivated(_.featureFlag)) return false;
    if (!!_.hideWhenEnabled && hasFeatureFlagActivated(_.hideWhenEnabled)) return false;
    return true;
  });
};
